<script setup lang="ts">
import { onMounted, onUnmounted, watch } from 'vue';
import { RouterView, useRouter } from 'vue-router';
import PartyStrip from './PartyStrip.vue';
import TopBar from './TopBar.vue';
import { useParty } from '../../stores/party';
import { useSession } from '../../stores/session';

/**
 * Owns the two pieces of state every route depends on: the Discord session and
 * the party. The live roster socket is opened here and nowhere else.
 */
const session = useSession();
const party = useParty();
const router = useRouter();

onMounted(async () => {
  await session.load();
  if (session.isSignedIn.value) {
    const returnPath = sessionStorage.getItem('garmoth-return-path');
    sessionStorage.removeItem('garmoth-return-path');
    if (returnPath?.startsWith('/') && !returnPath.startsWith('//')) await router.replace(returnPath);
    await party.refresh();
  }
});

watch(
  () => session.isSignedIn.value,
  async signedIn => {
    if (signedIn) await party.refresh();
    else party.clear();
  },
);

watch(
  () => party.party.value?.id,
  partyId => {
    party.stopLive();
    if (partyId) party.startLive();
  },
);

onUnmounted(() => party.stopLive());
</script>

<template>
  <div class="min-h-dvh">
    <a
      href="#content"
      class="sr-only focus-visible:not-sr-only focus-visible:absolute focus-visible:left-3 focus-visible:top-3 focus-visible:z-40 focus-visible:rounded-md focus-visible:border focus-visible:border-card focus-visible:bg-card focus-visible:px-3 focus-visible:py-2 focus-visible:text-[13px]"
    >
      Skip to content
    </a>
    <TopBar />
    <PartyStrip />
    <main id="content" class="mx-auto w-full max-w-screen-2xl pb-10">
      <RouterView />
    </main>
  </div>
</template>
